import { BaseFieldRenderer } from './base-field-renderer';
import { TextFieldRenderer } from './text-field-renderer';
import { EmailFieldRenderer } from './email-field-renderer';
import { DropdownFieldRenderer } from './dropdown-field-renderer';
import { TextareaFieldRenderer } from './textarea-field-renderer';
import { NumberFieldRenderer } from './number-field-renderer';
import { TelFieldRenderer } from './tel-field-renderer';
import { UrlFieldRenderer } from './url-field-renderer';
import { DateFieldRenderer } from './date-field-renderer';
import { CheckboxFieldRenderer } from './checkbox-field-renderer';
import { RadioFieldRenderer } from './radio-field-renderer';
import { FileFieldRenderer } from './file-field-renderer';
import { HiddenFieldRenderer } from './hidden-field-renderer';
import { PasswordFieldRenderer } from './password-field-renderer';
import { FirstNameFieldRenderer } from './firstname-field-renderer';
import { LastNameFieldRenderer } from './lastname-field-renderer';
import { CompanyNameFieldRenderer } from './companyname-field-renderer';
import { BirthdayFieldRenderer } from './birthday-field-renderer';
import { SignatureFieldRenderer } from './signature-field-renderer';
import { SubscribeFieldRenderer } from './subscribe-field-renderer';

export class FieldRendererFactory {
    private renderers = new Map<string, BaseFieldRenderer>(
        [
            ['text', new TextFieldRenderer()],
            ['email', new EmailFieldRenderer()],
            ['firstname', new FirstNameFieldRenderer()],
            ['lastname', new LastNameFieldRenderer()],
            ['companyname', new CompanyNameFieldRenderer()],
            ['birthday', new BirthdayFieldRenderer()],
            ['signature', new SignatureFieldRenderer()],
            ['subscribe', new SubscribeFieldRenderer()],
            ['textarea', new TextareaFieldRenderer()],
            ['tel', new TelFieldRenderer()],
            ['url', new UrlFieldRenderer()],
            ['number', new NumberFieldRenderer()],
            ['date', new DateFieldRenderer()],
            ['dropdown', new DropdownFieldRenderer()],
            ['checkbox', new CheckboxFieldRenderer()],
            ['radio', new RadioFieldRenderer()],
            ['file', new FileFieldRenderer()],
            ['hidden', new HiddenFieldRenderer()],
            ['password', new PasswordFieldRenderer()]
        ]
    );

    public getRenderer(fieldType: string): BaseFieldRenderer {
        const renderer = this.renderers.get(fieldType.toLowerCase());
        if (!renderer) {
            throw new Error(`No renderer registered for field type: ${fieldType}`);
        }

        return renderer;
    }
}
